import _ from 'lodash'

class MultipleValuesModalController {
  constructor($uibModalInstance, values, validLength, MultipleValuesService) {
    this.$uibModalInstance = $uibModalInstance
    this.MultipleValuesService = MultipleValuesService
    this.values = this.MultipleValuesService.collapseArrayToString(values)
    this.foundBadValues = false
    this.validValueLength = validLength
  }

  confirm() {
    const parsedValues = this.MultipleValuesService.parseStringToArray(this.values)
    const badValues = this.MultipleValuesService.invalidValues(parsedValues, this.validValueLength)
    if (badValues.length !== 0) {
      this.foundBadValues = true
      this.badValuesCount = badValues.length
    } else {
      this.$uibModalInstance.close({ values: parsedValues })
    }
  }

  cancel() {
    this.$uibModalInstance.dismiss(null)
  }
}

MultipleValuesModalController.$inject = [
  '$uibModalInstance',
  'values',
  'validLength',
  'MultipleValuesService']

export default MultipleValuesModalController
